import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import VerificationBlocked from '@/components/auth/VerificationBlocked';

export default function OnboardingGuard() {
  const { user } = useAuth();

  if (user?.verification_blocked && user.role !== 'admin') return <VerificationBlocked />;

  // If the user already has a Square customer ID they are fully linked — don't block them.
  // onboarding_complete may be missing on accounts created before the flag was introduced.
  if (user && !user.onboarding_complete && !user.square_customer_id) {
    return <Navigate to="/Onboarding" replace />;
  }

  return <Outlet />;
}